import { Maybe } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React, { FC } from 'react'
import {
  TopicBylineForEditor,
  TopicBylineForStudent
} from './components/byline/TopicByline'

export const TopicVersionTitleAndSummary: FC<{
  title?: Maybe<string> | string | undefined
  summary?: Maybe<string> | string | undefined
  isPreview?: boolean
}> = ({ title, summary, isPreview = false }) => {
  return (
    <div className="page-content page-content-title">
      <div className="element element-system-generated-title">
        <h1 className="topic-title">{title}</h1>
        {isPreview ? <TopicBylineForEditor /> : <TopicBylineForStudent />}
        <p className="topic-summary">{summary}</p>
      </div>
    </div>
  )
}

export default TopicVersionTitleAndSummary
